define('modules/content_recommendations/modal/auto_publish_settings_model',['backbone', 'session'], function (Backbone, session) {
  'use strict';
  var AutoPublishSettings = Backbone.Model.extend({
    defaults: {
      campaignType: 'tacticaloffer',
    },
    url: function () {
      return (
        session.get('apiUrl') + 'autopublishsettings?campaignType=' + this.get('campaignType')
      );
    },
  });

  return AutoPublishSettings;
});

